import request from '../utils/request'
import setting from './apiSetting'

const TYPE = 'User'

const myfunction = {
  GetSubUsersTrackers: function (data) {
    return request({
      url: setting.getFullUrl(TYPE, 'GetSubUsersTrackers'),
      method: 'get',
      params: data,
    })
  },

  GetAnnouncement: function () {
    return request({
      url: setting.getFullUrl(TYPE, 'GetAnnouncement'),
      method: 'get',
    })
  },

  /**
   * 获取所有警类的汇总
   */
  GetAlarmType: function (formData) {
    return request({
      url: setting.getFullUrl(TYPE, 'GetUserAlarmType'),
      method: 'post',
      data: formData,
    })
  },

  /**
   * 获取用户信息
   */
  GetSimpleUser: function (data) {
    return request({
      url: setting.getFullUrl(TYPE, 'GetSimpleUser'),
      method: 'get',
      params: data,
    })
  },

  /**
   * 获取用户信息
   */
  GetSimpleUserInfo: function (data) {
    return request({
      url: setting.getFullUrl(TYPE, 'GetSimpleUserInfo'),
      method: 'get',
      params: data,
    })
  },

  /**
   * 更换用户信息
   */
  UpdateUser: function (data) {
    return request({
      url: setting.getFullUrl(TYPE, 'UpdateUser'),
      method: 'get',
      params: data,
    })
  },

  /**
   * 更换用户密码
   */
  UpdateUserPass: function (data) {
    return request({
      url: setting.getFullUrl(TYPE, 'UpdateUserPassword'),
      method: 'get',
      params: data,
    })
  },

  /**
   * 修改台年数
   */
  UpdateUserCredit: function (data) {
    return request({
      url: setting.getFullUrl(TYPE, 'UpdateUserCredit'),
      method: 'post',
      params: data,
    })
  },

  /**
   * 批量修改设备过期提醒天数
   */
  BatchUpdateTrackerRemindDays: function (data) {
    return request({
      url: setting.getFullUrl(TYPE, 'BatchUpdateTrackerRemindDays'),
      method: 'post',
      data: data,
    })
  },

  //把所有子用户信息导出到excel
  exportExcel: function (page, params, filename) {
    const timeoutTimer = setTimeout(() => {
      page.loadingInstance.close()
      page.$Tools.showtipMessage(page, page.$t('requestOverTime'), 'error')
    }, 30000)
    page
      .axios({
        url: setting.getFullUrl(TYPE, 'ExcelExport'),
        params: params,
        method: 'post',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('ms_token'),
          'Accept-Language': localStorage.getItem('language'),
        },
        responseType: 'blob',
      })
      .then((res) => {
        clearTimeout(timeoutTimer)
        page.loadingInstance.close()
        if (res.data) {
          if (res.data.size > 0) {
            let suffix = '.xlsx'
            const blob = new Blob([res.data])
            //创建下载链接
            let link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.setAttribute('download', filename + suffix)
            link.click()
            link = null
          } else {
            page.$message.warning(page.$t('tips.emptyData'))
          }
        } else {
          page.$message.warning(res.data.msg)
        }
      })
      .catch((error) => {
        clearTimeout(timeoutTimer)
        page.loadingInstance.close()
        if (error.response && error.response.status === 400) {
          page.$message.error(error.response.data?.message)
        } else {
          const errorMsg = error.response?.data?.message || 'export error'
          page.$message.error(errorMsg)
        }
      })
  },
}

export default myfunction
